module.exports = __webpack_public_path__ + "img/Equipa_Seg_1.d18a88aa.png";